import { render, staticRenderFns } from "./sub-result.vue?vue&type=template&id=da590a22&"
import script from "./sub-result.vue?vue&type=script&lang=js&"
export * from "./sub-result.vue?vue&type=script&lang=js&"
import style0 from "./sub-result.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports